import { Container } from 'hypo-container';
import { getDecorators } from '@estee/elc-service';
import { OrderTrackingService } from './OrderTrackingService';
import { ServiceBusController } from './ServiceBusController';
import OrderTrackingViewController from '../internal/controllers/OrderTrackingViewController';
import { OrderRepository } from '../internal/repositories/OrderRepository';
import { OrderTrackingApiSdk } from '../api/OrderTrackingApiSdk';
import { ConfigRepository } from '../internal/repositories/ConfigRepository';
import { ELCLogger } from '@estee/elc-logging';
import { HttpTransport } from '@estee/elc-http-transport';
import { IAppConfig } from '@estee/elc-universal-utils';
import { OrderTrackingInformationViewController } from '../internal/controllers/OrderTrackingInformationViewController';
import { OrderStatusViewController } from '../internal/controllers/OrderStatusViewController';

export const serviceNames = {
    orderTrackingService: 'ORDER_TRACKING_SERVICE',
    serviceBusController: 'SERVICE_BUS_CONTROLLER',
    orderRepository: 'ORDER_TRACKING_ORDER_REPOSITORY',
    orderTrackingViewController: 'ORDER_TRACKING_VIEW_CONTROLLER',
    orderTrackingInformationViewController: 'ORDER_TRACKING_INFORMATION_VIEW_CONTROLLER',
    orderStatusViewController: 'ORDER_STATUS_VIEW_CONTROLLER',
    orderTrackingApiSdk: 'ORDER_TRACKING_API_SDK',
    configRepository: 'CONFIG_REPOSITORY',
    httpTransport: 'HTTP_TRANSPORT',
    logger: 'LOGGER'
};

const { name } = __serviceInfo__;

export const diContainer = new Container();

export const setConfig = (config: IAppConfig) => {
    diContainer.config = config;
};

diContainer
    .register(serviceNames.httpTransport, () => new HttpTransport())
    .register(serviceNames.configRepository, (c) => new ConfigRepository(c.config))
    .register(serviceNames.logger, () => new ELCLogger({ serviceName: name }))
    .register(serviceNames.serviceBusController, () => new ServiceBusController())
    .register(serviceNames.orderTrackingApiSdk, (c) => {
        return new OrderTrackingApiSdk(
            c.get(serviceNames.logger),
            c.get(serviceNames.httpTransport)
        );
    })
    .register(
        serviceNames.orderRepository,
        (c) => new OrderRepository(c.get(serviceNames.orderTrackingApiSdk))
    )
    .register(serviceNames.orderTrackingViewController, (c) => {
        return new OrderTrackingViewController(
            c.get(serviceNames.orderRepository),
            c.get(serviceNames.configRepository)
        );
    })
    .register(serviceNames.orderTrackingInformationViewController, (c) => {
        return new OrderTrackingInformationViewController(c.get(serviceNames.orderRepository));
    })
    .register(
        serviceNames.orderStatusViewController,
        diContainer.factory(
            (c) => new OrderStatusViewController(c.get(serviceNames.orderRepository))
        )
    )
    .register(
        serviceNames.orderTrackingService,
        (c) =>
            new OrderTrackingService((config: IAppConfig) => {
                setConfig(config);

                return c.get(serviceNames.serviceBusController);
            })
    );

export const { lazyInject } = getDecorators(diContainer);
